import { render, staticRenderFns } from "./CheckoutNotes.vue?vue&type=template&id=3522b91a&scoped=true"
import script from "./CheckoutNotes.vue?vue&type=script&lang=js"
export * from "./CheckoutNotes.vue?vue&type=script&lang=js"
import style0 from "./CheckoutNotes.vue?vue&type=style&index=0&id=3522b91a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3522b91a",
  null
  
)

export default component.exports